import { render, staticRenderFns } from "./TitleBarOnlyText.vue?vue&type=template&id=d175a4f4"
import script from "./TitleBarOnlyText.vue?vue&type=script&lang=js"
export * from "./TitleBarOnlyText.vue?vue&type=script&lang=js"
import style0 from "./TitleBarOnlyText.vue?vue&type=style&index=0&id=d175a4f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports